import {cloneElement, createContext, useContext, useState} from "react";
import { createPortal } from "react-dom";
import { HiXMark } from "react-icons/hi2";
import styled from "styled-components";
import {useOutsideClick} from "../hooks/UseOutsideClick.js";

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(8px);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: fadeIn 0.3s ease-in-out;

    pointer-events: auto; /* ✅ Let it catch clicks */

    @keyframes fadeIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

const StyledModal = styled.div`
    pointer-events: auto;

    background-color: white;
    border-radius: 1rem;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    width: 100%;
    max-width: 680px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    z-index: 1001;
    margin: 1rem;
`;





const ModalContent = styled.div`
    overflow-y: auto;
    padding: 0;
    flex-grow: 1; /* Take all remaining space after button */
`;

const Button = styled.button`
    background: none;
    border: none;
    padding: 0.5rem;
    border-radius: 50%;
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;

    &:hover {
        background-color: #f0f0f0;
    }

    & svg {
        width: 2rem;
        height: 2rem;
        color: #333;
    }
`;

export const ModalContext = createContext();

function Modal({ children }) {
    const [openName, setOpenName] = useState('');
    const close = () => setOpenName('');
    const open = setOpenName;
    
    return <ModalContext.Provider value={{ openName, close, open }}>
        {children}
        </ModalContext.Provider>
}

function Open({ children, opens: opensWindowName }) {
    const { open } = useContext(ModalContext);
    return cloneElement(children, { onClick: () => open(opensWindowName)});
}

function Window({ children, name }) {
    const { openName, close } = useContext(ModalContext);

    const ref = useOutsideClick(close);
    
    if(name !== openName) return null;
    
    return createPortal(
        <Overlay>
            <StyledModal ref={ref}>
                <Button onClick={close}>
                    <HiXMark />
                </Button>

                <ModalContent>
                    {cloneElement(children, { onCloseModal: close })}
                </ModalContent>
            </StyledModal>
        </Overlay>,
        document.body
    );
}

Modal.Open = Open;
Modal.Window = Window;

export default Modal;
